import mapObj from 'map-obj';

import { router } from './capsule-routes';
import { FileTemplate } from './files-store';
import { ComponentMeta } from './component-meta';

type generateDefaultCodeProps = {
	capsuleType: string;
	targetComponent?: ComponentMeta;
};

function generateDefaultCode({ capsuleType, targetComponent }: generateDefaultCodeProps) {
	if (!targetComponent || !targetComponent.id) return { files: {}, mainFile: 'index.js' };

	const capsuleDefinition = router.get(capsuleType);
	if (!capsuleDefinition) throw new Error(`no such capsule type as "${capsuleType}"`);

	const { generateDefaultCode } = capsuleDefinition;
	if (!generateDefaultCode) throw new Error('missing default code generator');

	return generateDefaultCode({ npmId: targetComponent.id });
}

export function calcMainFile(capsuleType: string) {
	const capsuleDefinition = router.get(capsuleType);
	if (!capsuleDefinition) return undefined;

	return capsuleDefinition.mainFile;
}

export function generateDefaultExample({
	capsuleType,
	targetComponent,
}: generateDefaultCodeProps) {
	const generated = generateDefaultCode({ capsuleType, targetComponent });

	const { files, ...rest } = generated;

	return {
		...rest,
		files: mapObj(generated.files, (path, content) => 
			[path as string, new FileTemplate(path as string, content).toObj()]
		)
	};
}
